import { COUPON_STATUS } from "@/constants/coupon";
import useAppStore from "@/context/store";
import { getCounpons } from "@/services";
import { safeParse } from "@/utils/safeParse";
import useRequest from "@/utils/useReq";
import { useEffect } from "react";
import { create } from "zustand";
export const HB_AVATAR_RED_TIP_DATA = "HB_AVATAR_RED_TIP_DATA";

export const useRedTipState = create(() => ({
  /**优惠券提示 */
  couponTip: false,
  couponIds: [],
  /**未支付订单提示 */
  orderTip: false,
}));

/**
 * 获取本地数据
 */
function getLocalData() {
  return typeof window === "undefined"
    ? {}
    : safeParse(localStorage.getItem(HB_AVATAR_RED_TIP_DATA) || "{}") || {};
}

export const useInitRedTipState = () => {
  const { unPayOrders, couponNum } = useAppStore(
    ({ unPayOrders, couponNum }) => ({
      unPayOrders,
      couponNum,
    })
  );

  const { data: couponIds } = useRequest(
    async () => {
      if (couponNum) {
        const res = await getCounpons({ status: COUPON_STATUS.GOT });
        if (res?.list?.length) {
          useRedTipState.setState({ couponIds: res.list.map((el) => el.id) });
          return res.list.map((el) => el.id);
        }
      }
    },
    {
      refreshDeps: [couponNum],
    }
  );

  useEffect(() => {
    // 用户已点击知道的优惠券ID
    const { readCouponIds = [], readOrderIds = [] } = getLocalData();

    // 优惠券提醒
    if (couponIds?.length) {
      for (let i = 0; i < couponIds.length; i++) {
        if (!readCouponIds.includes(couponIds[i])) {
          useRedTipState.setState({
            couponTip: true,
            couponIds,
          });
          break;
        }
      }
    }

    if (unPayOrders.length) {
      for (let i = 0; i < unPayOrders.length; i++) {
        const order = unPayOrders[i];
        if (!readOrderIds.includes(order.id)) {
          useRedTipState.setState({
            orderTip: true,
          });
          break;
        }
      }
    }
  }, [couponNum, unPayOrders, couponIds]);
};

// 维护用户已点击知道的优惠券ID与订单ID
export const useLocalStorageRedTip = () => {
  const { readCouponIds = [], readOrderIds = [] } = getLocalData();

  const setLocalStorage = (value) => {
    localStorage.setItem(
      HB_AVATAR_RED_TIP_DATA,
      JSON.stringify({
        ...(safeParse(localStorage.getItem(HB_AVATAR_RED_TIP_DATA)) || {}),
        ...value,
      })
    );
  };

  const setReadCouponIds = (ids = []) => {
    setLocalStorage({ readCouponIds: ids });
  };

  const setReadOrderIds = (ids = []) => {
    setLocalStorage({ readOrderIds: ids });
  };

  return {
    readCouponIds,
    readOrderIds,
    setReadCouponIds,
    setReadOrderIds,
  };
};
